import travisPic from "@/public/images/artists/travis.jpeg";
import { Artist } from "@/types/types";

export const travis = {
  id: "119",
  name: "Travis",
  image: travisPic,
  description: `Travis embodies a distinctive vocal style suited to grunge and alternative rock. His voice carries a raw, gritty timbre with a raspy undertones and impassioned intensity.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ftravis-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Rock", "Punk", "Alternative", "Belting", "Gritty"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 50,
        high: 70,
      },
    },
  },
} as const satisfies Artist;
